<template>
    <FieldItem
        :id="id"
        :label="$t(fieldConfig.label)"
    >
        <template slot="label">
            <span>{{ $t(fieldConfig.label) }}</span>
            <ElPopover
                :visible-arrow="false"
                :width="366"
                placement="right"
                trigger="hover"
                popper-class="bio-search-setting__popover"
            >
                <PreferencesPropver
                    :type="'gaps'"
                    :img-src="store.safeImagesUrl('ungappedExplanation')"
                />
                <PtIcon
                    slot="reference"
                    icon="SolidInfo"
                />
            </ElPopover>
        </template>
        <div class="search-preference__gaps-label">
            <label class="search-preferences--radio">
                <input
                    v-model="fieldValue"
                    :value="true"
                    type="radio"
                    @change="syncChange"
                >
                <span class="search-preferences--value">
                    {{ $t('Search.labels.yes') }}
                </span>
            </label>
            <label class="search-preferences--radio">
                <input
                    v-model="fieldValue"
                    :value="false"
                    type="radio"
                    @change="syncChange"
                >
                <span class="search-preferences--value">
                    {{ $t('Search.labels.no') }}
                </span>
            </label>
        </div>
    </FieldItem>
</template>

<script>
import Popover from 'element-ui/lib/popover';
import PtIcon from '@patsnap-biz/icon';
import FieldItem from '../components/FieldItem.vue';
import { FieldItemMixin } from './mixins';
import PreferencesPropver from '../explanations/PreferencesPropver.vue';

export default {
    components: {
        FieldItem,
        ElPopover: Popover,
        PreferencesPropver,
        PtIcon,
    },
    mixins: [FieldItemMixin],
    inject: ['store'],
    props: {
        fieldName: {
            type: String,
            default: 'ungapped',
        },
    },
};
</script>
